import normalizeApiError from '../utils/apiError';

import { engineApi } from './api';

export const submitRequest = async (payload) => {
  try {
    const { data } = await engineApi.post('/request', payload);
    return { success: true, data };
  } catch (error) {
    return normalizeApiError(error, {
      context: 'submitting request'
    });
  }
};

export const getRequest = async (id) => {
  try {
    const { data } = await engineApi.get(`/request/${id}`);
    return { success: true, data };
  } catch (error) {
    return normalizeApiError(error, {
      context: 'getting request'
    });
  }
};